export function filterNulls<T>(list: (T | null)[] | null | undefined): T[] {
  if (list) {
    return list.filter((value): value is T => value !== null);
  } else {
    return [];
  }
}
